<div class="form-editor-tools">
  <!--
      <div class="subpane bigger">
          Formato &nbsp;
          <select id="device-display-opts">
              <option value="phone portrait">Smartphone (vertical)</option>
              <option  selected="selected" value="tablet7 portrait">Tablet (vertical)</option>
              <option value="tablet7 landscape">Tablet (horizontal)</option>
          </select>
      </div>
  -->

  <div class="subpane" id="form-tools-pane">
    <div class="subpane tabbed" id="form-divisions-pane" style="display:xnone;">
      <button class="add-section-btn" ref="#section-block-dlg"><br />Sección<p>divide en partes</p></button>
      <button class="add-list-btn" ref="#list-block-dlg"><br />Tabla<p>lista variable de items</p></button>
      <button class="add-paragraph-btn" ref="#paragraph-block-dlg"><br />Párrafo<p>texto aclaratorio</p></button>
      <!-- ... mas adelante ...
              <button id="add-list-btn" ref="#list-block-dlg"><br/>Lista<p>lista variable de items</p></button>
              <button id="add-table-btn" ref="#table-block-dlg"><br/>Tabla<p>lista variable de items</p></button>
              <button class="add-grid-btn" ref="#grid-block-dlg"><br/>Grilla<p>como tabla</p></button>
          -->
      <p class="small">
        Divide al formulario en diferentes
        partes, y organízalo de modo mas amigable y ordenado.
      </p>
    </div>
    <div class="form-fields-pane subpane tabbed" id="form-inputs-pane" style="display:xnone;">
      <button ref="#text-input"><br />Texto<p>diferentes textos</p></button>
      <button ref="#number-input"><br />Número<p>diferentes números</p></button>
      <button ref="#date-input"><br />Fecha<p>fechas y/o horas</p></button>
      <button ref="#time-input"><br />Hora<p>solamente horas</p></button>
      <button ref="#check-input"><br />Tildar<p>elegir <br />si o no</p></button>
      <button ref="#option-input"><br />Opción<p>selecciona opciones</p></button>
      <button ref="#object-selector"><br />Ítem<p>de una lista</p></button>
      <button ref="#qrcode-capture"><br />Código<p>leer código QR/barras</p></button>
      <button ref="#photo-capture"><br />Fotos<p>tomar una o más fotos</p></button>
      <button ref="#attachs-capture"><br />Adjuntos<p>asociar uno o más archivos</p></button>
      <button ref="#gps-capture"><br />GPS<p>leer usando el GPS</p></button>
      <button ref="#calculation-logic"><br />Calculado<p>valor calculado</p></button>
      <button ref="#concatenation-logic"><br />Concatena<p>enlazar uno o más campos</p></button>
      <button ref="#graph-view"><br />Gráfico<p>uno o más valores</p></button>
      <button ref="#signature-capture"><br />Firma<p>digital</p></button>
      <button ref="#base64-field"><br />Base 64<p>base 64</p></button>
      <p class="small">
        Ingresa valores tales como diferentes tipos de textos, números,
        fechas y horas, y muchos más ...
      </p>
    </div>
    <div class="form-fields-pane subpane tabbed" id="form-logicals-pane" style="display:xnone;">
      <button class="hidden" ref="#conditional-logic"><br />Mostrar <br />(NO USAR)<p>aplicable entre campos</p>
        </button>
      <button ref="#conditional-logic-sections"><br />Mostrar sección<p>aplicable entre campos</p></button>
      <button ref="#conditional-logic-fields"><br />Mostrar campos<p>aplicable entre campos</p></button>
      <button ref="#conditional-logic-rows"><br />Filtrar las filas<p>aplicable entre campos</p></button>
      <button ref="#list-columns-copy"><br />Copiar columnas<p>columnas de una lista</p></button>
      <button ref="#more-options"><br />Opciones particulares<p>de este formulario</p></button>
      <!--
            <button ref="#list-operation-logic">Operación<p>sobre una lista</p></button>
            <button ref="#list-column-logic">Muestra<p>la columna de una lista</p></button>
            <p>&nbsp;</p>
            <p>Permiten definir cálculos entre campos del formulario
              (por ej. para calcular un descuento o un total), o aplicar
              ciertas formulas prearmadas.
            </p>
          -->
      <p class="small">
        Realiza operaciones entre campos tales como
        ocultar o mostrar campos en base a cierta condición y otras ...
      </p>
    </div>
    <div class="form-fields-pane subpane tabbed" id="form-plugins-pane" style="display:xnone;">
      <button ref="#local-stock-plugin"><br />Stock<p>calcula stock asignado</p></button>
      <button ref="#local-ticket-plugin"><br />Ticket<p>emite ticket</p></button>
      <button ref="#email-alert-plugin"><br />Alerta<p>envia alerta por correo</p></button>
      <button ref="#remote-call-plugin"><br />Solicitud<p>solicita valor remoto</p></button>
      <button ref="#pdf-fusion-plugin"><br />Fusión PDF<p>une dos PDFs</p></button>
      <button ref="#local-updatelist-plugin"><br />Actualizar lista <p>local</p></button>
      <p class="small">
        Utiliza módulos prearmados para resolver ciertos
        casos complejos, o <a class="aside">solicita uno a tu medida.</a>
      </p>
    </div>
  </div>
</div>